import type { IApiResponse } from "@litres-libs/types";
import type { RequestAddUserReferral } from "./lfrom.types";
import { rtkqApi } from "../api/rtkqApi";

export const lfromApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    addUserReferral: build.mutation<
      void,
      {
        referral_id: RequestAddUserReferral["referral_id"];
        referral_pin?: RequestAddUserReferral["referral_pin"];
        art_id?: RequestAddUserReferral["art_id"];
      }
    >({
      query({ referral_id, referral_pin, art_id }) {
        return {
          url: "/foundation/api/users/referral",
          method: "POST",
          body: {
            referral_id,
            referral_pin,
            art_id,
          },
        };
      },
    }),
    getReferrerPayDays: build.query<number, { referrer_id: number }>({
      query({ referrer_id }) {
        return {
          url: `/foundation/api/referrals/referrers/${referrer_id}`,
          method: "GET",
        };
      },
      transformResponse: (response: IApiResponse<{ pay_days: number }>) => {
        return response.payload.data.pay_days;
      },
    }),
    registerFirstLfromVisit: build.mutation<string, { referral_id: number }>({
      query({ referral_id }) {
        return {
          url: `/foundation/api/referrals/click`,
          method: "POST",
          body: {
            referral_id,
          },
        };
      },
    }),
  }),
});
